import { keys } from '@companyon/constants';
import qs from 'qs';
const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
export function maybeRecoverIds() {
    if (!window.location.search) {
        return false;
    }
    const q = qs.parse(window.location.search.slice(1));
    if (q.hasOwnProperty('ids')) {
        recoverIdsLowLevel(q);
        return true;
    }
    else {
        return false;
    }
}
export function destructure(key) {
    const s = localStorage[key];
    if (s === null || s === undefined) {
        return null;
    }
    try {
        return JSON.parse(s);
    }
    catch (error) {
        console.info('Error destructuring ' + s);
        return undefined;
    }
}
export function cutDownToStringArray(arr) {
    let retval = [];
    if (arr && Array.isArray(arr)) {
        for (const e of arr) {
            if (typeof e === 'string') {
                retval.push(e);
            }
        }
    }
    return retval;
}
export function cutDownToUuidArray(arr) {
    let retval = [];
    if (arr && Array.isArray(arr)) {
        for (const e of arr) {
            if (typeof e === 'string' && uuidRegex.test(e)) {
                retval.push(e);
            }
        }
    }
    return retval;
}
export function cutDownToUuidToMaybeUuid(obj) {
    let retval = {};
    if (obj && typeof obj === 'object') {
        for (const [k, v] of Object.entries(obj)) {
            if (typeof k === 'string' &&
                uuidRegex.test(k) &&
                typeof v === 'string' &&
                (v === '' || uuidRegex.test(v))) {
                retval[k] = v;
            }
        }
    }
    return retval;
}
function recoverIdsLowLevel(q) {
    let deviceId = localStorage.getItem(keys.DEVICE_ID);
    let blacklist = cutDownToStringArray(destructure(keys.ID_BLACKLIST));
    let deviceIds = cutDownToStringArray(destructure(keys.DEVICE_IDS));
    let bearerTokens = cutDownToUuidToMaybeUuid(destructure(keys.BEARER_TOKEN));
    let recoveryIds = cutDownToUuidToMaybeUuid(q['ids']);
    let deviceIdChanged = false;
    let bearerTokenChanged = false;
    for (const [k, v] of Object.entries(recoveryIds)) {
        if (!deviceIds.includes(k) && !blacklist.includes(k)) {
            console.info(`Recovering deviceId ${k}`);
            deviceIds.push(k);
            deviceIdChanged = true;
        }
        if (v !== '' && !bearerTokens.hasOwnProperty(k)) {
            console.info(`Recovering bearerToken[${k}]=${v}`);
            bearerTokens[k] = v;
            bearerTokenChanged = true;
        }
    }
    if (deviceId && !deviceIds.includes(deviceId)) {
        deviceIds.push(deviceId);
        deviceIdChanged = true;
    }
    // Set in an order preventing other tabs from using half-filled device infos
    if (bearerTokenChanged) {
        localStorage.setItem(keys.BEARER_TOKEN, JSON.stringify(bearerTokens));
    }
    if (deviceIdChanged) {
        localStorage.setItem(keys.DEVICE_IDS, JSON.stringify(deviceIds));
        if (!deviceId && deviceIds.length > 0) {
            localStorage.setItem(keys.DEVICE_ID, deviceIds[0]);
        }
    }
    return deviceIdChanged || bearerTokenChanged;
}
//# sourceMappingURL=recoverIds.js.map